// FXShilajit Countdown Timer - Custom JavaScript
// File: fxshilajit-countdown.js

document.addEventListener('DOMContentLoaded', function() {
  // Set the countdown to end on July 20 at 11:59 PM
  // Format: new Date(year, monthIndex, day, hours, minutes, seconds)
  // Note: monthIndex is 0-based (0=January, 6=July)
  const fxshilajitCountDownDate = new Date();
  
  // Get current year
  const currentYear = fxshilajitCountDownDate.getFullYear();
  
  // Set end date to July 20 of current year at 23:59:59
  const endDate = new Date(currentYear, 6, 20, 23, 59, 59);
  
  // If July 20 has already passed this year, set for next year
  if (fxshilajitCountDownDate > endDate) {
    endDate.setFullYear(currentYear + 1);
  }
  
  // Update the countdown every 1 second
  const fxshilajitCountdownFunction = setInterval(function() {
    // Get current date and time
    const now = new Date().getTime();
    
    // Calculate remaining time
    const distance = endDate - now;
    
    // Time calculations
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
    // Display results
    document.getElementById("fxshilajit-days").innerHTML = days.toString().padStart(2, '0');
    document.getElementById("fxshilajit-hours").innerHTML = hours.toString().padStart(2, '0');
    document.getElementById("fxshilajit-minutes").innerHTML = minutes.toString().padStart(2, '0');
    document.getElementById("fxshilajit-seconds").innerHTML = seconds.toString().padStart(2, '0');
    
    // If countdown is over
    if (distance < 0) {
      clearInterval(fxshilajitCountdownFunction);
      document.querySelector(".fxshilajit-countdown-title").innerHTML = "OFFER HAS ENDED!";
      document.querySelector(".fxshilajit-countdown-subtitle").innerHTML = "Check back soon for our next FXShilajit promotion";
      document.querySelector(".fxshilajit-countdown-timer").style.display = "none";
    }
  }, 1000);
});